import { render } from "./ConfirmStep.vue?vue&type=template&id=46b08c0c&scoped=true"
import script from "./ConfirmStep.vue?vue&type=script&lang=js"
export * from "./ConfirmStep.vue?vue&type=script&lang=js"

import "./ConfirmStep.vue?vue&type=style&index=0&id=46b08c0c&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b08c0c"]])

export default __exports__